module.exports = __webpack_public_path__ + "static/aboutus_sample_1.48b8b94f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutus/aboutus_sample_1.png
// module id = 1086
// module chunks = 4035221647099